import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Star } from "lucide-react";

export default function ReviewsSlider() {
  const [reviews, setReviews] = useState([]);
  const [i, setI] = useState(0);
  useEffect(() => { api.get("/reviews").then(({ data }) => setReviews(data)); }, []);
  useEffect(() => {
    if (reviews.length < 2) return;
    const t = setInterval(() => setI((p) => (p + 1) % reviews.length), 4500);
    return () => clearInterval(t);
  }, [reviews]);
  if (reviews.length === 0) return null;
  const r = reviews[i];
  return (
    <div className="bg-navy text-ivory" data-testid="reviews-slider">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-center gap-3 text-center">
        <div className="flex gap-0.5 text-gold shrink-0">{Array.from({ length: r.rating || 5 }).map((_, k) => <Star key={k} size={13} fill="#C6A45C" />)}</div>
        <p className="text-sm sm:text-base text-ivory/90 italic truncate">„{r.text}"</p>
        <span className="text-gold text-sm shrink-0 hidden sm:inline">— {r.name}, {r.city}</span>
      </div>
    </div>
  );
}
